
import React from 'react';

 function getQuery(search) {
    let query =  new URLSearchParams(search);
    let id = query.get("id")
    let phone = query.get("phone")
    let debug =query.get("debug")
    let screen = query.get("screen")
    let view = query.get("view")
    let demoweb = query.get("demoweb")
    let demowapp = query.get("demowapp")
    let test = query.get("test")
    let table = query.get("table")

    let demoinfo= query.get("demoinfo")
    let demopay= query.get("demopay")
    let demofees= query.get("demofees")

    return {
      id: id, 
      phone: phone, 
      debug:debug,
      screen:screen,
      view:view, 
      demoweb:demoweb,
      test:test, 
      table:table, 
      demowapp:demowapp,
      demoinfo:demoinfo, 
      demopay:demopay,
      demofees:demofees,
    };
  }; 

  function getMeta(name){
    let result = document.querySelector(`meta[name='${name}']`)?.content
    return result;
  }

   function getPath(env,paths){
     //console.log('paths: ', paths);
     //console.log('env: ', env);
     if(env!='production'){
      return  paths.home 
     }

     const appView = getMeta("app-view");
     let path; 
     if(appView==="delivery"){
       path=paths.store 
     }else if(appView==="local"){
      path=paths.local 
     }else if(appView==="qr"){
       path=paths.qr 
     }else if(appView=="ticket"){
       path=paths.ticket
     }else{
      path=paths.qr 
     }

     return path 
   }

  export {
    getQuery, 
    getMeta, 
    getPath
  }
